import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { FeatureLocatedModel } from '../feature-located-model';
import type { FeatureLocatedState } from '../../types';

@injectable()
export class FeatureLocatedModelImpl extends AbstractModel<FeatureLocatedState> implements FeatureLocatedModel {
    protected _modelData: FeatureLocatedState = {
        patentId: '',
        originText: '',
        matchText: '',
        nodeGroups: [],
        currentGroup: 1,
    };
}